export default __webpack_public_path__ + "locales/pt-BR/InfoPanel.json?hash=2d9e2460331601ba65c5f4c391e168d3";